import * as React from 'react';
import { Link, useLocation } from 'react-router-dom';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import AnalyticsRoundedIcon from '@mui/icons-material/AnalyticsRounded';
import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import SavingsIcon from '@mui/icons-material/Savings';

const mainListItems = [
  { text: 'Startseite', icon: <HomeRoundedIcon />, path: '/' },
  { text: 'Zahlprotokoll', icon: <SavingsIcon />, path: '/register' },
  // These two items should be conditionally rendered based on the role
  { text: 'Kassenbericht', icon: <AssignmentRoundedIcon />, path: '/report' },
  { text: 'Analyse', icon: <AnalyticsRoundedIcon />, path: '/analytics', adminOnly: true },
  { text: 'Einstellungen', icon: <SettingsRoundedIcon />, path: '/settings', adminOnly: true  },
];
export default function MenuContent({ role }) {
  const location = useLocation(); // Get the current route

  return (
    <Stack sx={{ flexGrow: 1, p: 1, justifyContent: 'space-between' }}>
      <List dense>
        {mainListItems.map((item, index) => {
          // Only render items with adminOnly set to true if the role is 'admin'
          if (item.adminOnly && role !== 'admin') {
            return null; // Skip rendering if the user is not an admin
          }
          return (
            <ListItem key={index} disablePadding sx={{ display: 'block' }}>
              <ListItemButton
                component={Link}
                to={item.path}
                selected={location.pathname === item.path}
                sx={{
                  mb: 1,
                  minHeight: 48, // Increased height
                  borderRadius: 2,
                }}
              >
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </Stack>
  );
}
